export const URL= process.env.REACT_APP_URL
export const URL_AUTH= process.env.REACT_APP_URL_AUTH